import React from 'react';

const ConfirmDeleteModal = ({ show, invoiceId, onConfirm, onCancel }) => {
  if (!show) return null;

  return (
    <div id="confirmDeleteModal" className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg p-6 max-w-sm w-full shadow-xl transform transition-all sm:my-8 sm:align-middle">
        <h3 className="text-lg font-bold text-gray-900 leading-6">Confirm Deletion</h3>
        <div className="mt-2">
          <p className="text-sm text-gray-500">
            Are you sure you want to delete invoice "<span id="invoiceIdSpan" className="font-bold text-gray-800">{invoiceId}</span>"? This action cannot be undone.
          </p>
        </div>
        <div className="mt-5 sm:mt-6 flex justify-end space-x-3">
          <button
            id="cancelBtn"
            type="button"
            className="inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            id="deleteConfirmBtn"
            type="button"
            className="inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:w-auto sm:text-sm"
            onClick={() => onConfirm(invoiceId)}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
